









































































































import {Vue, Component, Prop,Watch } from 'vue-property-decorator';
import * as api from '@/store/api'
import * as letterOwnerService from '@/store/Services/letterOwnerService';
import {LetterOwnerEmail} from '@/store/models/LetterOwner/LetterOwnerEmail';
import {LetterOwnerCellphone} from '@/store/models/LetterOwner/LetterOwnerCellphone';
import {LetterOwnerPhone} from '@/store/models/LetterOwner/LetterOwnerPhone';
import {faxEmailReceiver} from '@/store/models/LetterOwner/faxEmailReceiver';
import { LetterOwnerFax } from '@/store/models/LetterOwner/LetterOwnerFax';
import store from '@/store';
import { CompanyBranchPhone } from '@/store/models/CompanyBranch/CompanyBranchPhone';
import * as companyBranchServices from '@/store/Services/companyBranchServices';


@Component({
})
export default class DetailContactMobile extends Vue {
    isLoading= false;
    companyAddress='';
    latitude=0;
    longitude=0;
    postalCode='';
    name = '';
    companyName = '';
    post = '';
    picture='';
    isBranch= false;
    emails: LetterOwnerEmail[] = [];
    cellphones:  LetterOwnerCellphone[] = [];
    phones: LetterOwnerPhone[] = [];
    branchPhones: CompanyBranchPhone[]=[]
    internalLine ='';
    faxes:  LetterOwnerFax[]= [];
    faxEmailReceiver = {} as faxEmailReceiver ;
    created(){
        store.state.eventHub.$on('loadCompanyPersonel',this.loadCompanyPersonnelContactInfo)
        store.state.eventHub.$on('loadPersonelDetails',this.loadPersonnelContactInfo)
        store.state.eventHub.$on('loadCompanyBranchContactInfo',this.loadCompanyBranchContactInfo)

    }
    async loadCompanyBranchContactInfo(id: string){
        try {
            this.isBranch=true;
            this.isLoading=true;
            this.name = ' ';
            this.picture='';
            this.companyName = '' ;
            this.companyAddress = '' ;
            this.latitude = 0 ;
            this.longitude = 0 ;
            this.postalCode = '';
            this.branchPhones=[];
            const serverResult = await companyBranchServices.CompanyBranchContactInfoById(id);
            if(serverResult.companyName!=null){
                this.name = serverResult.name +' ';
                this.picture=serverResult.companyPicture;
                this.companyName = serverResult.companyName ;
                this.companyAddress = serverResult.address ;
                this.latitude = serverResult.latitude ;
                this.longitude = serverResult.longitude ;
                this.postalCode = serverResult.postalCode;
                this.branchPhones.push(...serverResult.phones);
            }
     
        } catch (error) {
            console.log(error);
        }finally{
            this.isLoading=false;
        }
    }

    async loadPersonnelContactInfo(id: string){
              
        try {
            this.isLoading=true;
            this.isBranch=false;
            this.name = '';
            this.companyName = '';
            this.post = '';
            this.picture='';
            this.internalLine ='';
            this.faxes=[];
            this.faxEmailReceiver={} as faxEmailReceiver
            this.emails =[];
            this.phones =[];
            this.cellphones=[];
            const serverResult = await letterOwnerService.getPersonnelContactInfo(id);
            this.name = serverResult.name +' '+serverResult.lastname;
            this.picture=serverResult.picture;
            this.post = serverResult.post;
            this.emails.push(...serverResult.emails);
            this.phones.push(...serverResult.phones);
            this.cellphones.push(...serverResult.cellphones);
            this.internalLine =serverResult.internalPhoneNumber;

        } catch (error) {
            console.log(error);
        }finally{
            this.isLoading=false;
        }
    }

    closeDetailContactbook(){
        this.$emit('closeDetailContactbook');
    }
    
    async loadCompanyPersonnelContactInfo(id: string){
        try {
            this.isLoading=true;
            this.isBranch=false;
            this.emails =[];
            this.phones =[];
            this.cellphones=[];
            this.faxes=[];
            this.name = '';
            this.companyName = '';
            this.post = '';
            this.picture='';
            this.internalLine ='';
            this.faxes=[];
            this.faxEmailReceiver={} as faxEmailReceiver
            this.emails =[];
            this.phones =[];
            this.cellphones=[];
            const serverResult = await letterOwnerService.getCompanyPersonnelContactInfo(id);
            if(serverResult.companyName!=null){
                this.name = serverResult.name +' ';
                this.picture=serverResult.companyPicture;
                this.companyName = serverResult.companyName ;
                this.post = serverResult.post;
                this.emails.push(...serverResult.emails);
                this.phones.push(...serverResult.phones);
                this.cellphones.push(...serverResult.cellphones);
                this.internalLine =serverResult.internalPhoneNumber;
                this.faxEmailReceiver =serverResult.faxEmailReceiver;
                this.faxes.push(...serverResult.faxes);
            }
     
        } catch (error) {
            console.log(error);
        }finally{
            this.isLoading=false;
        }
    }
}

